// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about_wrapper__tLrsW","quoteBlock":"about_quoteBlock__iJ3Vu","quoteText":"about_quoteText__yKa45","quote":"about_quote__MzsFt","quoteImg":"about_quoteImg__sEwYS"};